import React from "react";
import { CustomFormContext } from "./CustomFormContext";
import _ from "lodash";

export const CustomFormProvider = ({ children }) => {
    const [customforms,setCustomforms] = React.useState([]);
    const setLoading = (id,status) => {
        setCustomforms(prevState => {
            let index = _.findIndex(prevState, { id: id });
            if (index > -1) {
                prevState.splice(index, 1, { ...(prevState[index]), loading:status });
        //   console.log('【setLoading】', prevState.length, prevState);
                return _.clone(prevState);
            } else {
                return prevState;
            }
        });
    }
    const setVisible = (id,status) => {
        setCustomforms(prevState => {
            let index = _.findIndex(prevState, { id: id });
            if (index > -1) {
                prevState.splice(index, 1, { ...(prevState[index]), visible:status });
                console.log('【setVisible】', prevState.length, prevState);
                return _.clone(prevState);
            } else {
                return prevState;
            }
        });
    }

    const getCustomForm = (id) => {
        const target = _.find(customforms,item=>item.id == id);
        if(target == null){
            return { loading:false,visible:false };
        } else {
            return target;
        }
    }
    const putCustomform = (id, customform) => {
        //setCustomforms([...customforms,])
        setCustomforms(prevState => {
            let index = _.findIndex(prevState, { id: id });
            if (index < 0) {
                return [...prevState, { id: id, ...customform }];
            } else {
                prevState.splice(index, 1, { ...(prevState[index]), id: id, ...customform });
                console.log('【putCustomform】', prevState.length, prevState);
                return _.clone(prevState);
            }
        });
    }
    // const [loading, setLoading] = React.useState(false);
    // const [schema, setSchema] = React.useState(null);
    // const [formdata, setFormdata] = React.useState({});
    // const [visible, setVisible] = React.useState(false);
    return (<CustomFormContext.Provider value={{
        setVisible,
        setLoading,
        getCustomForm,
        putCustomform
    }}>
        {children}
    </CustomFormContext.Provider>);
}